import React from 'react'

//
import { FeatureSimpleBlock } from '../../../storybook'
import { getUrl } from '../../../utils/urls'
import { LocationContext } from '../../page-wrapper'
import { useNavigationData } from '@/src/context/NavigationContext'

const BlockFeatureSimple = ({
  data: {
    title,
    preface,
    background,
    simpleContentBlocks = [],
    featureCardBlocks = [],
    _description,
    _action,
    _image,
    _video,
    _orientation
  }
}) => {
  const { navigationItems } = useNavigationData()
  const location = React.useContext(LocationContext)
  const { slugPrefix } = location
  let features = []
  if (featureCardBlocks.length === 0 && simpleContentBlocks && simpleContentBlocks.length > 0) {
    features = simpleContentBlocks.map(
      ({ id, title, icon, description, action, bulletListColor }, i) => ({
        id: `${id}-${i}`,
        title: title || '',
        icon: icon || '',
        description: description || '',
        bulletListColor: bulletListColor || null,
        action: action
          ? {
              text: action.title || '',
              small: false,
              url: getUrl({
                navItem: action,
                slugPrefix: slugPrefix,
                navigationItems: navigationItems
              })
            }
          : null
      })
    )
  }
  if (featureCardBlocks && featureCardBlocks.length > 0) {
    features = featureCardBlocks.map(
      ({ id, title, icon, image, description, action, bulletListColor, logo }, i) => ({
        id: `${id}-${i}`,
        title: title || '',
        icon: logo || icon || '',
        bulletListColor: bulletListColor || null,
        image: image || null,
        description: description || '',
        textTokens: {},
        action: action
          ? {
              text: action.title || '',
              small: false,
              url: getUrl({
                navItem: action,
                slugPrefix: slugPrefix,
                navigationItems: navigationItems
              })
            }
          : null
      })
    )
  }

  return (
    <FeatureSimpleBlock
      title={title}
      eyebrow={preface}
      features={features}
      background={background}
    />
  )
}

export default BlockFeatureSimple
